var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlexDollarA(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 13.3333V6.66667C2.5 5.74619 3.24619 5 4.16667 5H15.8333C16.7538 5 17.5 5.74619 17.5 6.66667V13.3333C17.5 14.2538 16.7538 15 15.8333 15H4.16667C3.24619 15 2.5 14.2538 2.5 13.3333Z",
    stroke: "#060F21",
    strokeWidth: 1.66667
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.8335 5.83337V5.83337C5.8335 7.21409 4.71421 8.33337 3.3335 8.33337V8.33337",
    stroke: "#060F21",
    strokeWidth: 1.66667
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.8335 14.1666V14.1666C5.8335 12.7859 4.71421 11.6666 3.3335 11.6666V11.6666",
    stroke: "#060F21",
    strokeWidth: 1.66667
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1665 5.83337V5.83337C14.1665 7.21409 15.2858 8.33337 16.6665 8.33337V8.33337",
    stroke: "#060F21",
    strokeWidth: 1.66667
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1665 14.1666V14.1666C14.1665 12.7859 15.2858 11.6666 16.6665 11.6666V11.6666",
    stroke: "#060F21",
    strokeWidth: 1.66667
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6668 8.33337H9.16683C8.70659 8.33337 8.3335 8.70647 8.3335 9.16671V9.16671C8.3335 9.62694 8.70659 10 9.16683 10H10.8335C11.2937 10 11.6668 10.3731 11.6668 10.8334V10.8334C11.6668 11.2936 11.2937 11.6667 10.8335 11.6667H8.3335",
    stroke: "#060F21",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10 7.5L10 12.5",
    stroke: "#060F21",
    strokeWidth: 1.66667,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlexDollarA);
export default __webpack_public_path__ + "static/media/flexDollarA.4470cf853cdc739c3c44611107afeb39.svg";
export { ForwardRef as ReactComponent };